import { useEffect } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const REFRESH_KEY = "__skeleton_auto_refresh__";

export const PageSkeleton = () => {
  useEffect(() => {
    const alreadyRefreshed = sessionStorage.getItem(REFRESH_KEY);
    if (alreadyRefreshed) return;

    const timer = setTimeout(() => {
      sessionStorage.setItem(REFRESH_KEY, "true");
      window.location.reload();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto space-y-8">
        <Skeleton className="h-12 w-3/4" />
        <Skeleton className="h-6 w-1/2" />
        
        <div className="grid md:grid-cols-2 gap-6 mt-12">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="space-y-4">
              <Skeleton className="aspect-video w-full rounded-lg" />
              <Skeleton className="h-6 w-3/4" />
              <Skeleton className="h-4 w-full" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
